import { Component, OnInit } from '@angular/core';
import { RedirectService } from './services/redirect.service';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile, KeycloakTokenParsed } from 'keycloak-js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  title = 'Servicios en Linea SSO';
  public isLoggedIn = false;
  public userProfile: KeycloakProfile | null = null;
  public userToken: string | null = null;
  public userRefreshToken: string | undefined;
  public decodedToken: KeycloakTokenParsed | undefined;

  constructor(private redirect: RedirectService, private readonly keycloak: KeycloakService){

  }

  public async ngOnInit() {
    this.isLoggedIn = await this.keycloak.isLoggedIn();
    const host = window.location.host;
    const protocol = window.location.protocol;
    if (this.isLoggedIn) {
      this.userProfile = await this.keycloak.loadUserProfile();
      this.userToken = await this.keycloak.getToken();
      this.userRefreshToken = await this.keycloak.getKeycloakInstance().refreshToken;
      this.decodedToken = await this.keycloak.getKeycloakInstance().tokenParsed;
      var arreglo;
      if(this.userProfile.username !== undefined && this.userProfile.firstName !== undefined && this.userProfile.lastName !== undefined && this.userProfile.email !== undefined){
        arreglo = {usuario:this.userProfile.username, nombre:this.userProfile.firstName, apellido:this.userProfile.lastName, email:this.userProfile.email}
      }
      console.log(this.decodedToken);
      var param = {tokenSSO:this.userToken, refreshTokenSSO:this.userRefreshToken, userProfile:JSON.stringify(arreglo)};
      this.redirect.post(param,protocol+"//"+host+"/servilinea/ServiLinea/Portada.php");
    }
  }
}
